module.exports = __webpack_public_path__ + "img/pal-blue.128e0737.svg";